import { IRoute } from "shared/interface/types";
import { familyPlanB2BRoutes } from "./shelfPlanRoute/B2BRoute";

export const FamilyRoutes: IRoute[] = [...familyPlanB2BRoutes];
